import Rails from '@rails/ujs'
import.meta.glob('../images/**/*');
if (!window._rails_loaded) {
  Rails.start();
}

import '../stylesheets/biz_spa/application.scss';
import { createApp, h } from "vue";
import { sync } from "vuex-router-sync";
import router from "../src/biz_spa/router.js";
import { store } from "../src/biz_spa/store.js";
import { I18n, locale } from "../src/biz_spa/plugins/i18n";
import { mapState, mapActions } from "vuex";
import axios from "axios";
import VueAxiosPlugin from "../src/biz_spa/plugins/axios";
import { flashPlugin } from "../src/biz_spa/plugins/flash";
import { setValidationLocale } from "../src/biz_spa/plugins/vee-validate";
import ValidationObserver from "../src/biz_spa/components/ValidationObserver.vue";
import ValidationProvider from "../src/biz_spa/components/ValidationProvider.vue";
import App from "../src/biz_spa/views/App.vue";
import { createPinia } from 'pinia';
// localeによって動的にimportしたいが、importにテンプレートリテラルが使えないのでとりあえずimportしておく
import 'moment/dist/locale/ja'
import VueGtag from "vue-gtag";
const pinia = createPinia();

sync(store, router);

router.beforeEach((to) => {
  if (gon.currentUser) {
    // 初期登録が終わっていない状態での他画面への遷移をリダイレクト
    if (
      gon.currentUser.registration_in_progress &&
      !to.path.includes("registrations")
    ) {
      return {
        name: "RegistrationsBrand",
        params: { company_uuid: gon.currentUser.invited_companies[0].uuid },
      };
    }

    // 初期登録が終わっている状態での初期登録画面への再アクセスをトップ画面へリダイレクト
    if (
      !gon.currentUser.registration_in_progress &&
      to.path.includes("registrations")
    ) {
      return {
        path: `/s/companies/${gon.currentUser.invited_companies[0].uuid}/dashboards`,
      };
    }
  }
});

createApp({
  computed: {
    ...mapState(["locale"]),
  },
  watch: {
    locale(val) {
      this.changeLocale(val);
    },
  },
  created() {
    if (this.locale === "") {
      this.setLocale({ locale });
    }
    if (this.locale !== "") {
      this.changeLocale(this.locale);
    }
  },
  methods: {
    ...mapActions(["setLocale"]),
    changeLocale(locale) {
      setValidationLocale(locale);
    },
  },
  render: () => h(App),
})
  .use(pinia)
  .use(I18n)
  .use(router)
  .use(store)
  .use(VueAxiosPlugin, { axios: axios })
  .use(flashPlugin)
  .use(VueGtag, {
    pageTrackerTemplate(to) {
      return {
        page_title: to.name,
        parameters: to.query ?
          Object.entries(to.query).map(
            ([key, value]) => ((value && value.length) ? `${key}_${value}` : null)
          ).filter((el) => el).join('_') : null,
        page_path: to.path,
        user_id: gon.currentUser.id,
        admin: gon.currentUser.admin,
        company_uuid: to.params.company_uuid,
        distributer_uuid: gon.currentUser.distributer_uuid
      }
    },
    config: {
      id: GOOGLE_MEASUREMENT_ID
    },
    pageTrackerSkipSamePath: false
  }, router)
  .component("ValidationObserver", ValidationObserver)
  .component("ValidationProvider", ValidationProvider)
  .mount("#bizSpa");
